import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import {EMPTY} from 'rxjs';
import * as SettingsActions from './settings.actions';
import {SettingsService} from './services';


@Injectable()
export class SettingsEffects {

    loadHandlinger$ = createEffect(() => this.actions$.pipe(
        ofType(SettingsActions.loadHandlinger),
        switchMap((action) => this.settingsService.getHandlinger(action.sagId).pipe(
            map(handlinger => SettingsActions.loadHandlingerSuccess({handlinger})),
            catchError(() => EMPTY)
        )))
    );

    loadHandlingerOptions$ = createEffect(() => this.actions$.pipe(
        ofType(SettingsActions.loadHandlingerOptions),
        switchMap(() => this.settingsService.getActionOptions().pipe(
            map(handlingerOptions => SettingsActions.loadHandlingerOptionsSuccess({handlingerOptions})),
            catchError(() => EMPTY)
        ))
    ));

    setFilterFromClient$ = createEffect(() => this.actions$.pipe(
        ofType(SettingsActions.setFilterFromClient),
        map((action) => {
            const options = {
                kundetype: action.client.kundetype,
                virksomhedsform: action.client.virksomhedsType,
                ydelser: action.client.ydelser?.split(',').map((x) => parseInt(x.trim(), 10)),
                klasse: action.client.kundeklasse,
                branche: action.client.brancheId
            };
            return SettingsActions.setFilter({partialFilterOptions: options});
        })
    ));

    storeHandling$ = createEffect(() => this.actions$.pipe(
        ofType(SettingsActions.storeHandling),
        switchMap((action) => this.settingsService.storeHandling(action.handling).pipe(
            map(handling => SettingsActions.storeHandlingSuccess({handling})),
            catchError(() => EMPTY)
        ))
    ));

    storeOmraade$ = createEffect(() => this.actions$.pipe(
        ofType(SettingsActions.storeOmraade),
        switchMap((action) => this.settingsService.storeOmraade(action.omraade).pipe(
            map(omraade => SettingsActions.storeOmraadeSuccess({omraade})),
            catchError(() => EMPTY)
        ))
    ));

    deleteAction$ = createEffect(() => this.actions$.pipe(
        ofType(SettingsActions.deleteHandling),
        switchMap((action) => this.settingsService.deleteHandling(action.handling.id).pipe(
            map(() => SettingsActions.deleteHandlingSuccess({id: action.handling.id})),
            catchError(() => EMPTY)
        ))
    ));

    deleteArea$ = createEffect(() => this.actions$.pipe(
        ofType(SettingsActions.deleteOmraade),
        switchMap((action) => this.settingsService.deleteOmraade(action.omraade.id).pipe(
            map(() => SettingsActions.deleteOmraadeSuccess({id: action.omraade.id})),
            catchError(() => EMPTY)
        ))
    ));


    updateHandlingerSort$ = createEffect(() => this.actions$.pipe(
        ofType(SettingsActions.updateHandlingerSort),
        switchMap((action) => this.settingsService.updateHandlingerSort(action.newSorteringList).pipe(
            map(() => SettingsActions.updateHandlingerSortSuccess({newSorteringList: action.newSorteringList}))
        ))
    ));

    updateHandlingerOmraaderSort$ = createEffect(() => this.actions$.pipe(
        ofType(SettingsActions.updateHandlingerOmraaderSort),
        switchMap((action) => this.settingsService.updateHandlingerOmraaderSort(action.newSorteringList).pipe(
            map(() => SettingsActions.updateHandlingerOmraaderSortSuccess({newSorteringList: action.newSorteringList}))
        ))
    ));

    constructor(
        private actions$: Actions,
        private settingsService: SettingsService,
    ) { }
}
